module.exports = __webpack_public_path__ + "static/media/990606.a18947b0.png";